import { storableError } from '../util/errors';
import { uploadDocument, deleteDocument, getDocument } from '../util/api';

// ================ Action types ================ //

export const FILE_UPLOAD_REQUEST = 'app/listings/FILE_UPLOAD_REQUEST';
export const FILE_UPLOAD_SUCCESS = 'app/listings/FILE_UPLOAD_SUCCESS';
export const FILE_UPLOAD_ERROR = 'app/listings/FILE_UPLOAD_ERROR';

export const FILE_DELETE_REQUEST = 'app/listings/FILE_DELETE_REQUEST';
export const FILE_DELETE_SUCCESS = 'app/listings/FILE_DELETE_SUCCESS';
export const FILE_DELETE_ERROR = 'app/listings/FILE_DELETE_ERROR';

export const FILE_DOWNLOAD_REQUEST = 'app/listings/FILE_DOWNLOAD_REQUEST';
export const FILE_DOWNLOAD_SUCCESS = 'app/listings/FILE_DOWNLOAD_SUCCESS';
export const FILE_DOWNLOAD_ERROR = 'app/listings/FILE_DOWNLOAD_ERROR';

// ================ Reducer ================ //

const uploadItemInitialState = {
  inProgress: true,
  error: null,
};
const deleteItemInitialState = {
  inProgress: true,
  error: null,
};

const downloadItemInitialState = {
  inProgress: true,
  error: null,
};

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FILE_UPLOAD_REQUEST:
      return {
        ...state,
        [payload]: uploadItemInitialState,
      };

    case FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        [payload.folderPath]: {
          ...state[payload.folderPath],
          inProgress: false,
          files: payload.uploadedFiles
        },
      };

    case FILE_UPLOAD_ERROR:
      return {
        ...state,
        [payload.folderPath]: {
          inProgress: false,
          error: payload.error,
        }
      };

    case FILE_DELETE_REQUEST:
      return {
        ...state,
        [payload]: deleteItemInitialState,
      };

    case FILE_DELETE_SUCCESS:
      return {
        ...state,
        [payload.folderPath]: {
          ...state[payload.folderPath],
          inProgress: false,
          files: payload.uploadedFiles,
        }
      };

    case FILE_DELETE_ERROR:
      return {
        ...state,
        [payload.key]: {
          inProgress: false,
          error: payload.error,
        }
      };

    case FILE_DOWNLOAD_REQUEST:
      return {
        ...state,
        [payload]: downloadItemInitialState,
      };

    case FILE_DOWNLOAD_SUCCESS:
      return {
        ...state,
        [payload.folderPath]: {
          ...state[payload.folderPath],
          inProgress: false,
          files: payload.uploadedFiles,
        }
      };

    case FILE_DOWNLOAD_ERROR:
      return {
        ...state,
        [payload.key]: {
          inProgress: false,
          error: payload.error,
        }
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const uploadFilesRequest = folderPath => ({
  type: FILE_UPLOAD_REQUEST,
  payload: folderPath,
});

export const uploadFilesSuccess = (folderPath, uploadedFiles) => ({
  type: FILE_UPLOAD_SUCCESS,
  payload: { folderPath, uploadedFiles },
});

export const uploadFilesError = (folderPath, error) => ({
  type: FILE_UPLOAD_ERROR,
  payload: { folderPath, error },
});

export const deleteFilesRequest = folderPath => ({
  type: FILE_DELETE_REQUEST,
  payload: folderPath,
});

export const deleteFilesSuccess = (folderPath, uploadedFiles) => ({
  type: FILE_DELETE_SUCCESS,
  payload: { folderPath, uploadedFiles },
});

export const deleteFilesError = (folderPath, error) => ({
  type: FILE_DELETE_ERROR,
  payload: { folderPath, error },
});

export const downloadFilesRequest = folderPath => ({
  type: FILE_DOWNLOAD_REQUEST,
  payload: folderPath,
});

export const downloadFilesSuccess = (folderPath, uploadedFiles) => ({
  type: FILE_DOWNLOAD_SUCCESS,
  payload: { folderPath, uploadedFiles },
});

export const downloadFilesError = (folderPath, error) => ({
  type: FILE_DOWNLOAD_ERROR,
  payload: { folderPath, error },
});


// ================ Selectors ================ //

export const $uploadState = state => {
  return state.upload;
};


// ================ Thunks ================ //

export const uploadFile = (file, folderPath, type, userId, entityId) => async (dispatch, getState, sdk) => {

  if (!file) return null;

  dispatch(uploadFilesRequest(folderPath));

  const formData = new FormData();
  formData.append('file', file);
  formData.append('folderPath', folderPath);
  formData.append('type', type);
  formData.append('userId', userId);
  formData.append('entityId', entityId);

  try {
    const uploadedFiles = await uploadDocument(formData);
    dispatch(uploadFilesSuccess(folderPath, uploadedFiles));
    return uploadedFiles;

  } catch (e) {
    dispatch(uploadFilesError(folderPath, storableError(e)));
  }
}

export const deleteFile = (key, type) => async (dispatch) => {
  try {
    const deletedFiles = deleteDocument(key, type)
    return deletedFiles

  } catch (e) {
    console.log(e)
  }
};

export const downloadFile = (key, folderPath) => async (dispatch) => {
  dispatch(downloadFilesRequest(folderPath));

  try {
    return getDocument(key);

  } catch (e) {
    dispatch(downloadFilesError(folderPath, storableError(e)));
  }
};
